const NAMESPACE = "customListSharedStrings";

const KEYS = {
    externalColumnHeader: "externalColumnHeader",
    keyColumnHeader: "keyColumnHeader",
    importHeader: "importHeader",
    typeHeader: "typeHeader",
    internalColumnHeader: "internalColumnHeader",

    yesLabel: "yesLabel",
    customListName: "customListName",

    typeLabelUnknown: "typeLabelUnknown",
    typeLabelInteger: "typeLabelInteger",
    typeLabelDecimal: "typeLabelDecimal",
    typeLabelAbsoluteUrl: "typeLabelAbsoluteUrl",
    typeLabelRelativeUrl: "typeLabelRelativeUrl",
    typeLabelBoolean: "typeLabelBoolean",
    typeLabelEmail: "typeLabelEmail",
    typeLabelString: "typeLabelString",

    duplicateColumnNameErrorMessage: "duplicateColumnNameErrorMessage"
};

const MESSAGES = {
    [KEYS.externalColumnHeader]: {
        value: "External Column Name",
        comment: "Label for the External Column Name header."
    },
    [KEYS.keyColumnHeader]: {
        value: "Key Column",
        comment: "Label for the Key Column header."
    },
    [KEYS.importHeader]: {
        value: "Import",
        comment: "Label for the Import header."
    },
    [KEYS.typeHeader]: {
        value: "Type",
        comment: "Label for the Type header."
    },
    [KEYS.internalColumnHeader]: {
        value: "Internal Column Name",
        comment: "Label for the Internal Column Name header."
    },

    [KEYS.yesLabel]: {
        value: "Yes",
        comment: "Label for Yes indicator on boolean properties."
    },
    [KEYS.customListName]: {
        value: "Custom List Name",
        comment: "Label for the name input for custom list name"
    },

    [KEYS.typeLabelUnknown]: {
        value: "Unknown",
        comment: "Label for the Unknown external column type."
    },
    [KEYS.typeLabelInteger]: {
        value: "Integer",
        comment: "Label for the Integer external column type."
    },
    [KEYS.typeLabelDecimal]: {
        value: "Decimal",
        comment: "Label for the Decimal external column type."
    },
    [KEYS.typeLabelAbsoluteUrl]: {
        value: "Absolute URL",
        comment: "Label for the AbsoluteUrl external column type."
    },
    [KEYS.typeLabelRelativeUrl]: {
        value: "Relative URL",
        comment: "Label for the RelativeUrl external column type."
    },
    [KEYS.typeLabelBoolean]: {
        value: "Boolean",
        comment: "Label for the Boolean external column type."
    },
    [KEYS.typeLabelEmail]: {
        value: "Email",
        comment: "Label for the Email external column type."
    },
    [KEYS.typeLabelString]: {
        value: "String",
        comment: "Label for the String external column type."
    },

    [KEYS.duplicateColumnNameErrorMessage]: {
        value: "Duplicate column name",
        comment: "Error message for when duplicate column names are specified."
    }
};

export { KEYS, NAMESPACE, MESSAGES };
